import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { RouterModule, Routes } from "@angular/router";
import { CdkTableModule } from "@angular/cdk/table";

import { NgxChartsModule } from "@swimlane/ngx-charts";

import { FuseSharedModule } from "@fuse/shared.module";
import { FuseWidgetModule } from "@fuse/components/widget/widget.module";
import { ListComponent } from "./list/list.component";
import { InquiriesService } from "@app/main/content/inquiry/list/inquiries.service";
import { DetailComponent } from "./detail/detail.component";
import { InquiryService } from "@app/main/content/inquiry/detail/inquiry.service";
import { MaterialModule } from "@app/material/material.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatPaginatorModule } from "@angular/material";

const routes: Routes = [
  {
    path: "inquires",
    component: ListComponent,
    resolve: {
      data: InquiriesService,
    },
  },
  {
    path: "detail/:id",
    component: DetailComponent,
    resolve: {
      data: InquiryService,
    },
  },
];

@NgModule({
  imports: [
    CommonModule,

    FormsModule,
    ReactiveFormsModule,

    RouterModule.forChild(routes),

    CdkTableModule,
    MaterialModule,
    MatPaginatorModule,

    NgxChartsModule,

    FuseSharedModule,
    FuseWidgetModule,
  ],
  declarations: [ListComponent, DetailComponent],
  providers: [InquiriesService, InquiryService],
})
export class InquiryModule {}
